'use strict';

var filterMap = require('./filter_config');
var UA = window.navigator.userAgent;

module.exports = function configFilter(cfgManager) {
    if (cfgManager.get('devMode')) return;

    cfgManager.addFilter('base', filterMap['base']);

    if (/MicroMessenger/.test(UA)) {
        cfgManager.addFilter('weixin', filterMap['weixin']);
    } else if (/dp\/com\.dianping/.test(UA)) {
        cfgManager.addFilter('dianping', filterMap['dianping']);
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/@dp/owl/lib/util/filter.js
// module id = 257
// module chunks = 0